import { PageHeader } from "@/components/site/PageHeader";
import { Seo } from "@/components/site/Seo";
import { VisionMission } from "@/components/site/VisionMission";
import { Team } from "@/components/site/Team";
import { SponsorDonne } from "@/components/site/SponsorDonne";
import { Manifesto } from "@/components/site/Manifesto";
import { ImageStrip } from "@/components/site/ImageStrip";
import { Stats } from "@/components/site/Stats";
import { Certifications } from "@/components/site/Certifications";
import { Gallery } from "@/components/site/Gallery";

export default function ChiSiamo() {
  return (
    <div data-testid="chi-siamo-page">
      <Seo
        title="Chi siamo | treffe — 3F Centro Formazione Frosinone"
        description="Simona De Vecchis e Emanuela guidano 3F Centro Formazione: consulenza sicurezza D.Lgs 81/08, certificazioni FGAS, bandi regionali e formazione BLS-D/AHA."
        path="/chi-siamo"
      />
      <PageHeader
        eyebrow="Chi siamo"
        title={<>Formazione che crea esperienza</>}
        subtitle="Siamo un centro di formazione e consulenza che mette al centro persone, sicurezza e prevenzione, affiancando le aziende a 360°."
      />
      <VisionMission />
      <Team />
      <SponsorDonne />
      <Manifesto />
      <ImageStrip />
      <Stats />
      <Certifications />
      <Gallery />
    </div>
  );
}
